import React from "react";
import NumberKeyboard from "./numberKeyboard";
import { KioskStepContainer } from "../styled/common"; // common 경로에 맞춰

const TelFields = ({ transformValue, formData, handleChangeInput }) => {
  const formatPhone = (value) => {
    if (!value) return "";
    const cleaned = value.replace(/\D/g, "");

    if (cleaned.length <= 3) return cleaned;
    if (cleaned.length <= 7) return `${cleaned.slice(0, 3)}-${cleaned.slice(3)}`;
    return `${cleaned.slice(0, 3)}-${cleaned.slice(3, 7)}-${cleaned.slice(7, 11)}`;
  };

  return (
    <KioskStepContainer
      className="slideContent"
      style={{ transform: `translateX(${transformValue}%)` }}
    >
      <div className="wrap">
        <div className="header">
          <div className="badge">STEP 2</div>
          <div className="title">전화번호 입력</div>
          <div className="sub">찾을 때 사용됩니다. 번호를 정확히 입력해주세요.</div>
        </div>

        <div className="card">
          <div className="inputBar">
            <input
              type="text"
              value={formatPhone(formData.tel)}
              readOnly
              placeholder="010-0000-0000"
            />
          </div>

          <div className="body">
            <NumberKeyboard
              type="tel"
              inputValue={formData.tel}
              handleChangeInput={handleChangeInput}
            />
          </div>
        </div>
      </div>
    </KioskStepContainer>
  );
};

export default TelFields;